import { TypedUseSelectorHook, useSelector } from "react-redux";
import { GroupsState } from "./GroupsReducer";
import { AppState } from "@grassrootly/rn-core";

const useGroupSelector: TypedUseSelectorHook<{ groups: GroupsState } & AppState> = useSelector;

export const usePlayerGroup = (id: number) => useGroupSelector(({ groups }) => id > 0 ? groups.playerGroups[id] || null : null);

export const usePlayerGroups = () => useGroupSelector(({ groups }) => groups.playerGroupsArray || null);

export const useGroups = (id: number) => useGroupSelector(({ groups }) => groups.groups[id] || null);
